import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { AUTH } from "@/constants/testIds/app";
import { AuthShell, Field } from "@/pages/Login";

export default function Signup() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await register(email, password, name);
      navigate("/home");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Begin your library">
      <form onSubmit={onSubmit} className="flex flex-col gap-4">
        <Field label="Your name">
          <input
            data-testid={AUTH.signupName}
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="input-cozy"
            placeholder="First name"
          />
        </Field>
        <Field label="Email">
          <input
            data-testid={AUTH.signupEmail}
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="input-cozy"
            placeholder="you@example.com"
          />
        </Field>
        <Field label="Password">
          <input
            data-testid={AUTH.signupPassword}
            type="password"
            required
            minLength={6}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="input-cozy"
            placeholder="At least 6 characters"
          />
        </Field>
        {error && (
          <p data-testid={AUTH.signupError} className="text-sm text-[#8B3A3A] bg-[#F5E9E6] px-3 py-2 rounded-[10px]">
            {error}
          </p>
        )}
        <button data-testid={AUTH.signupSubmit} type="submit" disabled={busy} className="btn-primary mt-2">
          {busy ? "Creating account…" : "Create account"}
        </button>
      </form>
      <p className="text-sm text-[#2C2520]/70 mt-6 text-center">
        Already have one?{" "}
        <Link data-testid={AUTH.switchToLogin} to="/login" className="text-[#4A5D4E] underline underline-offset-4">
          Sign in
        </Link>
      </p>
    </AuthShell>
  );
}
